import { render, staticRenderFns } from "./ApprovalEditGadai.vue?vue&type=template&id=030d96d1&"
import script from "./ApprovalEditGadai.vue?vue&type=script&lang=js&"
export * from "./ApprovalEditGadai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports